import { auth, db } from "../config/firebase";
import { collection, getDocs, orderBy, query } from "firebase/firestore";
import { createApi, fakeBaseQuery } from "@reduxjs/toolkit/query/react";
import { ErrorMessage, Model } from "@beyondrealityapp/core/shared/constants";
import { functions } from "../config/firebase";
import { httpsCallable } from "firebase/functions";
import { Payment } from "@beyondrealityapp/core/payment/classes";

export const paymentsApi = createApi({
  reducerPath: "paymentsApi",
  baseQuery: fakeBaseQuery(),
  tagTypes: ["Payments"],
  endpoints: (builder) => ({
    fetchPayments: builder.query<Payment[], void>({
      queryFn: async () => {
        const uid = auth.currentUser?.uid;
        if (!uid) {
          return { error: new Error(ErrorMessage.NO_ID) };
        }
        try {
          const paymentsRef = collection(db, Model.USERS, uid, Model.PAYMENTS);
          const q = query(paymentsRef, orderBy("processedAt", "desc"));
          const snapshot = await getDocs(q);
          const payments = snapshot.docs.map((doc) =>
            Payment.fromFirestore(doc.data()),
          );
          return { data: payments };
        } catch (error) {
          return { error: error as Error };
        }
      },
      providesTags: ["Payments"],
    }),
    cancelSubscription: builder.mutation<
      { success: boolean; accessUntil: string | null },
      void
    >({
      queryFn: async () => {
        try {
          const cancel = httpsCallable<
            void,
            { success: boolean; accessUntil: string | null }
          >(functions, "cancelSubscription");
          const result = await cancel();
          return { data: result.data };
        } catch (error) {
          return { error: error as Error };
        }
      },
      invalidatesTags: ["Payments"],
    }),
  }),
});

export const { useFetchPaymentsQuery, useCancelSubscriptionMutation } =
  paymentsApi;
